import * as React from "react";
import { forwardRef } from "react";
const SvgRadioButton = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 4, width: 16, height: 16, rx: 8, fill: "white" }), /* @__PURE__ */ React.createElement("rect", { x: 4.5, y: 4.5, width: 15, height: 15, rx: 7.5, stroke: "#473A2E", strokeOpacity: 0.15 }), /* @__PURE__ */ React.createElement("rect", { x: 7, y: 7, width: 10, height: 10, rx: 5, fill: "#F7F6F5" }));
const ForwardRef = forwardRef(SvgRadioButton);
export { ForwardRef as ReactComponent };
